// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__y7tNm","fadeIn":"styles_fadeIn__Ras14"};